import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent, Box, List,
  ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SecurityIcon from '@mui/icons-material/Security';
import ShieldIcon from '@mui/icons-material/Shield';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const services = [
  'Firewall setup and configuration (ASA, Pfsense, SonicWall)',
  'Cisco ISE Network Access Control (NAC)',
  'Zero Trust architecture implementation',
  'Network security assessment and audit',
  'Endpoint security and antivirus deployment',
  'VPN configuration and management',
  'Firewall rule auditing and hardening',
  'Security policy development and enforcement',
  'Intrusion detection and monitoring',
  'Active Directory security hardening',
  'Conditional access and MFA configuration',
  'Compliance reporting and documentation',
];

const benefits = [
  {
    icon: VerifiedUserIcon,
    title: 'CySA+ Certified',
    description: 'CompTIA CySA+ certified cybersecurity analyst with enterprise security experience',
  },
  {
    icon: SecurityIcon,
    title: 'Zero Trust Expert',
    description: 'Deployed Cisco ISE NAC policies ensuring Zero Trust compliance across 4000+ endpoints',
  },
  {
    icon: ShieldIcon,
    title: 'Firewall & NAC',
    description: 'Experienced with ASA, Pfsense, SonicWall firewalls and network access control',
  },
  {
    icon: NetworkCheckIcon,
    title: 'Threat Monitoring',
    description: 'Proactive network monitoring and incident response to keep your systems secure',
  },
];

function CybersecurityServices() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            Cybersecurity Services
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Enterprise-grade security solutions from a CompTIA CySA+ certified professional
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
              '&:hover': { background: 'linear-gradient(45deg, #3b82f6 30%, #2563eb 90%)' }
            }}
          >
            Schedule Security Assessment
          </Button>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Security Services Offered</Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default CybersecurityServices;
